import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  form: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  inputFormat: {
    "&.MuiFormControl-root": {
      margin: [theme.spacing(2), 0, 0, 0],
    },
  },
  TextField: {
    composes: "$inputFormat",
  },
  select: {
    composes: "$inputFormat",
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      transform: "translate(12px, -5px) scale(0.75)",
      background: theme.color.white,
    },
    '& div[data-placeholder-show^="true"] + .PlaceHolderText': {
      position: "relative",
      left: "18px",
      top: "-38px",
      pointerEvents: "none",
      "& span": {
        pointerEvents: "none",
      },
    },
    '& .MuiInputLabel-formControl + div[data-placeholder-show-label^="true"] + .PlaceHolderText':
      {
        display: "none",
      },
    '& .MuiInputLabel-formControl.Mui-focused.MuiInputLabel-filled.MuiInputLabel-shrink + div[data-placeholder-show-label^="true"] + .PlaceHolderText':
      {
        display: "inline",
        position: "relative",
        left: "14px",
        top: "-38px",
        pointerEvents: "none",
        "& span": {
          color: theme.color.gray3,
          pointerEvents: "none",
          fontSize: "16px",
        },
      },
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  categoryMenu: {
    "&.parent": {
      fontWeight: "bold",
      color: theme.color.blue,
    },
    "&.sous-cat": {
      fontWeight: "bold",
      paddingLeft: theme.spacing(5),
    },
    "&.sous-sous-cat": {
      paddingLeft: theme.spacing(7),
    },
  },
  selectedCategories: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
